import { render, staticRenderFns } from "./RenderSpinner.vue?vue&type=template&id=0ff19488&"
import script from "./RenderSpinner.vue?vue&type=script&lang=js&"
export * from "./RenderSpinner.vue?vue&type=script&lang=js&"
import style0 from "./RenderSpinner.vue?vue&type=style&index=0&id=0ff19488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports